// @flow

export default {
  "urn:jsonschema:eu:firstcare:api:v1:dto:absencerecording:absence:AbsenceCallReasonAndDurationDTO": [
    // Rule 1:
    // Remove consent to share if client settings do not require consent
    {
      tests: [{ path: "/settings/settings/clientSettings/blockConsent", value: true }],
      filters: ["hasConsentToShare"],
    },
  ],
};
